module.exports = __webpack_public_path__ + "fonts/IdeaBuddyFont.b3e2d728.ttf";